"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ContextMenu {
    parent;
    items = [];
    contextMenu = null;
    wrapperClass = '';
    propagateEvent = false;
    static CONTEXT_MENU_WRAPPER_PADDING = 8;
    boundCloseMainContextMenu = this.closeMainContextMenu.bind(this);
    actionPayload = {};
    onMenuOpen;
    onMenuClose;
    onItemHover;
    onItemExit;
    setOnMenuOpen(callback, callback2) {
        this.onMenuOpen = callback;
        this.onMenuClose = callback2;
    }
    setOnItemHover(callback, callback2) {
        this.onItemHover = callback;
        this.onItemExit = callback2;
    }
    setMenuItems(items) {
        this.contextMenu?.close();
        this.items = items;
        this.contextMenu = this.makeContextMenu();
    }
    setActionPayload(obj) {
        this.actionPayload = obj;
    }
    getActionPayload() {
        return this.actionPayload;
    }
    getItemByUID(uid, contextMenu = this.contextMenu) {
        const items = [];
        function searchItems(menu) {
            for (let i = 0; i < menu.items.length; i++) {
                const item = menu.items[i];
                if (item.id === uid) {
                    items.push(item);
                }
                if (item.contextMenu) {
                    searchItems(item.contextMenu);
                }
            }
        }
        searchItems(contextMenu);
        if (items.length === 0) {
            return [];
        }
        else
            return items;
    }
    constructor(element, { items = [], wrapperClass = '', scrollContainer = document, propagateEvent = false }) {
        this.parent = element;
        this.wrapperClass = wrapperClass;
        this.propagateEvent = propagateEvent;
        items.length > 0 &&
            this.setMenuItems(items);
        this.parent.addEventListener('contextmenu', this.openMainContextMenu.bind(this));
        scrollContainer.addEventListener('scroll', this.boundCloseMainContextMenu);
    }
    makeContextMenu(items = this.items, parentMenu = null) {
        const contextMenu = {
            wrapper: document.createElement('div'),
            element: document.createElement('div'),
            isOpen: false,
            subMenus: [],
            parentMenu,
            items: [],
            setIsOpen: (isOpen) => {
                contextMenu.isOpen = isOpen;
            },
            open: (x, y, parentElement = document.body) => {
                if (contextMenu.isOpen)
                    return;
                contextMenu.setIsOpen(true);
                parentElement.appendChild(contextMenu.wrapper);
                contextMenu.items.forEach(item => {
                    item.onOpen && item.onOpen(item);
                });
                if (!contextMenu.parentMenu) {
                    const rect = contextMenu.wrapper.getBoundingClientRect();
                    const overflow = {
                        x: rect.width + x > window.innerWidth,
                        y: rect.height + y > window.innerHeight,
                    };
                    contextMenu.wrapper.style.top = `${overflow.y ? y - rect.height : y}px`;
                    contextMenu.wrapper.style.left = `${overflow.x ? x - rect.width : x}px`;
                    contextMenu.wrapper.classList.toggle('from-bottom', overflow.y);
                }
                else {
                    contextMenu.wrapper.style.top = `${y}px`;
                    contextMenu.wrapper.style.left = `${x}px`;
                    if (contextMenu.wrapper.getBoundingClientRect().right + 80 > window.innerWidth) {
                        contextMenu.wrapper.style.left = `${x - contextMenu.parentMenu.wrapper.offsetWidth - contextMenu.wrapper.offsetWidth - ContextMenu.CONTEXT_MENU_WRAPPER_PADDING}px`;
                        contextMenu.wrapper.classList.add('from-right');
                    }
                    else {
                        contextMenu.wrapper.classList.remove('from-right');
                    }
                }
            },
            close: () => {
                if (!contextMenu.isOpen)
                    return;
                contextMenu.items.forEach(item => {
                    item.element.classList.remove('hovered');
                    item.element.dispatchEvent(new MouseEvent('mouseleave'));
                });
                contextMenu.setIsOpen(false);
                contextMenu.wrapper.remove();
                contextMenu.subMenus.forEach(subMenu => {
                    subMenu.close();
                });
            },
        };
        contextMenu.wrapper.classList.add('context-menu-wrapper');
        if (this.wrapperClass)
            contextMenu.wrapper.classList.add(this.wrapperClass);
        const contextMenuDiv = contextMenu.element;
        contextMenuDiv.classList.add('context-menu');
        contextMenu.wrapper.appendChild(contextMenuDiv);
        items.forEach(item => {
            const i = this.createItem(item, contextMenu);
            contextMenu.items.push(i);
            contextMenuDiv.appendChild(i.element);
        });
        return contextMenu;
    }
    createDivider() {
        const menuItem = {
            element: document.createElement('div'),
            label: 'divider',
            id: 'divider',
            remove: () => menuItem.element.remove(),
            enable: () => { },
            setLabel: () => { },
        };
        menuItem.element.classList.add('context-menu-divider');
        return menuItem;
    }
    createItem(item, contextMenu) {
        if (item === 'divider')
            return this.createDivider();
        const menuItem = {
            element: document.createElement('div'),
            label: item.label,
            id: item.id,
            onOpen: item.onOpen,
            enable: (enable) => {
                enable ? menuItem.element.classList.remove('disabled') : menuItem.element.classList.add('disabled');
            },
            remove: () => menuItem.element.remove(),
            setLabel: (label) => {
                menuItem.label = label;
                menuItem.element.querySelector('.context-menu-item-label').textContent = label;
            }
        };
        menuItem.element.classList.add('context-menu-item');
        menuItem.enable(!item.disabled);
        if (!item.isHtml)
            menuItem.element.innerHTML = `
			<div class="context-menu-item-info" data-label=${item.label}>
				${item.icon ? `<div class="context-menu-item-icon">
					<span class="material-symbols-rounded">${item.icon}</span>
				</div>` : ''}
				<div class="context-menu-item-label">
					${item.label}
				</div>
			</div>
			${item.children?.length > 0 ?
                `<div class="context-menu-item-arrow">
					<span class="material-symbols-rounded">arrow_forward_ios</span>
				</div>` : ''}
		`;
        else
            menuItem.element.innerHTML = item.label;
        menuItem.element.addEventListener('mouseover', (e) => {
            this.onItemHover && this.onItemHover(menuItem, e);
            menuItem.element.classList.add('hovered');
            contextMenu.subMenus.forEach(subMenu => {
                if (subMenu !== menuItem.contextMenu)
                    subMenu.close();
            });
            if (menuItem.contextMenu) {
                menuItem.contextMenu.open(menuItem.element.offsetLeft + menuItem.element.offsetWidth - ContextMenu.CONTEXT_MENU_WRAPPER_PADDING / 2, menuItem.element.offsetTop - ContextMenu.CONTEXT_MENU_WRAPPER_PADDING, menuItem.element);
            }
        });
        menuItem.element.addEventListener('mouseleave', (e) => {
            this.onItemExit && this.onItemExit(menuItem, e);
            menuItem.element.classList.remove('hovered');
        });
        if (item.children?.length > 0) {
            const subMenu = this.makeContextMenu(item.children, contextMenu);
            subMenu.wrapper.classList.add('sub');
            contextMenu.subMenus.push(subMenu);
            menuItem.contextMenu = subMenu;
        }
        else {
            menuItem.element.addEventListener('click', (e) => {
                if (item.action) {
                    item.action.call(this, {
                        ...this.actionPayload,
                        event: e,
                    });
                    this.closeMainContextMenu(e, true);
                }
            });
        }
        return menuItem;
    }
    openMainContextMenu(event) {
        if (this.onMenuOpen) {
            if (this.onMenuOpen(event) === false)
                return;
        }
        !this.propagateEvent && event.stopPropagation();
        event.preventDefault();
        this.contextMenu?.close();
        this.contextMenu?.open(event.clientX - ContextMenu.CONTEXT_MENU_WRAPPER_PADDING, event.clientY - ContextMenu.CONTEXT_MENU_WRAPPER_PADDING);
        document.addEventListener('click', this.boundCloseMainContextMenu);
    }
    closeMainContextMenu(event, force = false) {
        if (!force && event.target && event.target.closest('.context-menu-wrapper'))
            return;
        this.onMenuClose && this.onMenuClose(event);
        this.contextMenu?.close();
        document.removeEventListener('click', this.boundCloseMainContextMenu);
    }
}
exports.default = ContextMenu;
